// Pill.jsx
// Client: vmfive
// Version: 1.0.0

import './Pill.css';

export default function Pill({
  children,
  active = false,
  disabled = false,
  onClick,
  className = '',
}) {
  return (
    <button
      type="button"
      className={`pill ${active ? 'pill--active' : ''} ${className}`}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
